<template>
    <BaseContainer>
        <span slot="principal">
            <v-content class="pr-2 pl-2">
                <v-toolbar class="ma-2" style="border-radius: 30px;" dense>
                    <v-btn icon link to="/">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>

                    <v-toolbar-title v-show="$vuetify.breakpoint.smAndUp">Indicações</v-toolbar-title>

                    <v-spacer/>

                    <v-tabs v-if="podeConsultar" v-model="aba" centered show-arrows class="abas">
                        <v-tab>
                            <v-icon left small>mdi-cash-clock</v-icon>
                            Solicitações
                        </v-tab>
                        <v-tab>
                            <v-icon left small>mdi-account-multiple-plus-outline</v-icon>
                            Indicações
                        </v-tab>
                    </v-tabs>

                    <v-spacer/>
                </v-toolbar>

                <div v-if="!podeConsultar" class="pa-12 text-center grey--text">
                    <v-icon large color="grey">mdi-lock-outline</v-icon>
                    <div class="mt-2">Seu usuário não tem permissão para consultar indicações.</div>
                    <div class="text-caption">
                        Peça a um diretor para liberar em Usuários → Permissões.
                    </div>
                </div>

                <v-tabs-items v-else v-model="aba" touchless class="transparente">
                    <v-tab-item>
                        <TabSolicitacoes
                            ref="solicitacoes"
                            :pode-editar="podeEditar"
                            :pode-marcar-pago="podeMarcarPago"
                            @alterado="atualizarIndicacoes"
                        />
                    </v-tab-item>
                    <v-tab-item>
                        <TabIndicacoes ref="indicacoes" :pode-editar="podeEditar"/>
                    </v-tab-item>
                </v-tabs-items>
            </v-content>
        </span>
    </BaseContainer>
</template>

<script>
import BaseContainer from '@/components/BaseContainer';
import TabIndicacoes from './TabIndicacoes';
import TabSolicitacoes from './TabSolicitacoes';

export default {
    name: 'Indicacoes',

    components: {
        BaseContainer,
        TabIndicacoes,
        TabSolicitacoes,
    },

    data: () => ({
        aba: 0,
    }),

    computed: {
        podeConsultar() {
            return this.checkPermission('zapercontrol_indicacoes_consultar') || this.isDiretor();
        },

        podeEditar() {
            return this.checkPermission('zapercontrol_indicacoes_editar') || this.isDiretor();
        },

        podeMarcarPago() {
            return this.checkPermission('zapercontrol_indicacoes_marcar_pago') || this.isDiretor();
        },
    },

    methods: {
        atualizarIndicacoes() {
            this.$refs.indicacoes && this.$refs.indicacoes.recarregar();
        },
    },
};
</script>

<style scoped>
.abas {
    max-width: 380px;
}

.transparente >>> .v-window__container {
    background: transparent;
}
</style>
